
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BillStats } from "../types";

interface StatsCardsProps {
  stats: BillStats[];
}

export const StatsCards = ({ stats }: StatsCardsProps) => {
  return (
    <div className="grid grid-cols-4 gap-4 mb-8">
      {stats.map((stat) => (
        <Card key={stat.status}>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-gray-500">
              {stat.status.toUpperCase()}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{stat.count}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
